import api from './api';
import { RULE_SETS_TAG } from './ruleSets';
import { ADMIN_BID_SETUPS_TAG } from './bidSetups';

export { RULE_SETS_TAG, ADMIN_BID_SETUPS_TAG };

export default {
    [api.reducerPath]: api.reducer,
};
